import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotCardHealth = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <path
            fill={spotColor}
            fillRule="evenodd"
            d="M17.798 6.933c-3.35.756-8.67 2.033-12.548 5.833-3.878 3.81-6.665 10.498-4.485 14.332 2.192 3.823 9.352 4.78 15.657 6.315 6.317 1.545 11.77 3.665 15.58 1.95 3.798-1.713 5.934-7.25 7.07-12.02 1.145-4.77 1.27-8.762.156-12.1-1.1-3.337-3.462-6.01-6.148-6.89-2.698-.868-5.732.046-8.127.813-2.394.766-3.795 1-7.155 1.767Z"
            clipRule="evenodd"
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M30.8 22.925h-7.855m9.818-5.85h-9.818M5.273 7h29.454C36.535 7 38 8.455 38 10.25v19.5c0 1.795-1.465 3.25-3.273 3.25H5.273C3.465 33 2 31.545 2 29.75v-19.5C2 8.455 3.465 7 5.273 7Zm4.758 7.15h4.229v3.75h3.776v4.2H14.26v3.75h-4.23V22.1H6.255v-4.2h3.777v-3.75Z"
        />
    </SVG>
);
SpotCardHealth.displayName = "SpotCardHealth";
